<template>
  <div class="content">

    <el-card shadow="never">
      <!-- 查询 -->
      <el-row type="flex" justify="space-between">
        <el-form
          ref="searchForm"
          :model="searchForm"
          class="demo-form-inline"
          inline
        >
          <el-form-item label="产品名:" prop="like">
            <el-input
              v-model.trim="searchForm.like"
              placeholder="请输入产品名"
            />
          </el-form-item>
          <!-- <el-form-item label="客户姓名:" prop="userName">
            <el-input
              v-model.trim="searchForm.userName"
              placeholder="请输入客户姓名"
            />
          </el-form-item>
          <el-form-item label="订单金额:" prop="price">
            <el-input
              v-model.trim="searchForm.price"
              placeholder="请输入订单金额"
            />
          </el-form-item> -->
          <!-- <el-form-item label="讲师:" prop="lecturer">
            <el-select v-model="searchForm.lecturer" placeholder="请选择讲师">
              <el-option
                v-for="item in lecturerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch()"
              >查询
            </el-button>
            <el-button
              icon="el-icon-refresh-right"
              @click="handleClear()"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-row>
      <el-row class="rowSpace">
        <!-- <el-col :span="4">
          <el-button
            type="primary"
            size="small"
            @click="changeView('/order/add')"
            >创建订单</el-button
          ></el-col
        > -->

          <el-col :span="3">
          <el-button
            type="info"
            @click="dialogVisibleProduct = true"
            >导入产品</el-button
          ></el-col>

        <el-dialog title="添加实拍图" :visible.sync="dialogVisible" width="30%">       
          <el-upload
            ref="upload"          
            :action="uploadImageUrl"
            :on-success="handleSuccess"
            :on-error="handleError"
            :http-request="customRequest"
            multiple
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            
          </el-upload>
          <span slot="footer" class="dialog-footer">         
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button style="margin-left: 10px;" type="success" @click="submitImageUpload">开始上传</el-button>
          </span>
        </el-dialog>

        <el-dialog title="导入产品" :visible.sync="dialogVisibleProduct" width="30%">       
          <el-upload
            ref="upload"            
            :action="uploadProductUrl"
            :on-success="handleProductSuccess"
            :on-error="handleProductError"
            :http-request="customRequestProduct"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>      
          </el-upload>
          <span slot="footer" class="dialog-footer">         
            <el-button @click="dialogVisibleProduct = false">取 消</el-button>
            <el-button style="margin-left: 10px;" type="success" @click="submitProductUpload">开始导入</el-button>
          </span>
        </el-dialog>
 
        
        <!-- <el-col :span="8">
          <div>
            <el-radio-group
              size="small"
              @change="changeRadio($event)"
              v-model="searchForm.state"
            >
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="0">已上架</el-radio-button>
              <el-radio-button label="1">已下架</el-radio-button>
            </el-radio-group>
          </div>
        </el-col> -->
      </el-row>
      <!-- 表格 -->
      
      <el-table ref="table" :data="productData" border style="width: 100%" height="540" :header-cell-style="tableHeaderColor"
  >
      <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="商品图片" width="100"
         >
          <template slot-scope="scope">
            <div>
              <el-popover placement="right" trigger="hover">
                <el-image
                  style="height: 300px"
                  :src="scope.row.pictureUrl"
                  fit="contain"
                />
                <el-image
                  slot="reference"
                  style="height: 100px"
                  :src="scope.row.pictureUrl"
                  fit="contain"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="productName"
          label="商品名称"
         show-overflow-tooltip>
        </el-table-column>

        <!-- 其他列 -->
          <el-table-column label="实拍图" width="200"  >
            <template slot-scope="scope" >
              <div style="height: 100px;overflow-x: auto;white-space: nowrap; ">
                  <div v-for="(image, index) in scope.row.liveUrl" :key="index">
                <el-popover placement="right" trigger="hover">
                  <a :href="image" target="_blank">
                     <el-image
                      style="height: 300px"
                      :src="image"
                      fit="contain"
                    />
                  </a>
                 
                  <el-image
                    slot="reference"
                    style="height: 100px"
                    :src="image"
                    fit="contain"
                  />
                </el-popover>
              </div>
              </div>
              
            </template>
          </el-table-column>
          <!-- 其他列 -->
    
          
        <el-table-column
          prop="size"
          label="款式"
          width="100"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope" >
            <!-- <el-button
              type="success"
              size="small"
              @click="changeView('/order/update', { id: scope.row.id })"
              >编辑</el-button
            > -->
            <!-- <el-button
              type="danger"
              size="small"
              @click="deletecourse(scope.row.id)"
              >删除</el-button
            >
            <el-button
              type="warning"
              size="small"
              @click="changeCourseStatus(scope.row.id, 0)"
              >下架</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="changeCourseStatus(scope.row.id, 1)"
              >上架</el-button
            > -->
            <!-- <el-button size="small" @click="openDetail(scope.row.id)"
              >详情</el-button
            > -->
             <el-button size="small"  @click="AddProduct(scope.row.id)"
             > 添加实拍图</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        layout="->,total, prev, pager, next, jumper"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- 详情--->
      <!-- <Detail ref="course_detail" /> -->
    </el-card>
  </div>
</template>

<script>

import axios from 'axios';
export default {
  name: "courseManage",
  // components: { Detail },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleProduct: false,
      uploadImageUrl:"/api/images",
      uploadProductUrl:"/api/product/uploadExcelProduct",       
      searchForm: {
         //current: 1,
         limit: 50,
        page:1 ,
        classify: "",
        like: "",
        // lecturer: "",
        // state: "",
      },
      productId:0,
      total: 0, // 初始化应为 0，这里只做演示效果使用

      productData:[],
      lecturerList: [{ id: 123123, name: "知否君" }],
      products: [
        { name: 'Laptop', price: 1200 },
        { name: 'Mouse', price: 20 },
        { name: 'Keyboard', price: 50 },
        { name: 'Monitor', price: 300 },
        { name: 'Speaker', price: 100 }
      ],
      targetTotal: 1500, // 目标总价
      cart: [], // 购物车数组
      shippingFee: 0,
      couponDiscount: 0,
      total: 0 // 当前总价
    };
  },
  created() {
    // 初始化表格数据
    this.getPageList();
  },
  methods: {

  
 
    async getPageList() {
     const result = await this.$axios.get('/api/product/info', {
        params: this.searchForm,
      });
     if (result.data.code == 200) {
        
        this.productData = result.data.data.list;
        this.updateImageUrls();
        this.total = result.data.data.total;
      } else {
        this.$message.error(result.data.message);
      }
    },
    AddProduct(id){
        this.productId = id;
        this.dialogVisible = true;
    },
      // 点击上传按钮时触发
    submitImageUpload() {
      this.$refs.upload.submit();
    },
     customRequest(options) {
      const formData = new FormData();
      formData.append('files', options.file); //这里的 'file' 是后端接收文件的字段名
      formData.append('id', this.productId);
      axios.post(this.uploadImageUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        if(response.data.code == '200'){
          options.onSuccess(response.data.message);
          this.dialogVisible = false;
          this.getPageList();
        }else{
         options.onError(response.data.message);
        }   
      }).catch(error => {
        options.onError(error);
      });
    },
    // 文件上传成功的回调
    handleSuccess(response, file, fileList) {
      this.$message.success('上传成功');
      console.log('File uploaded successfully:', response);
      this.dialogVisible = false; // 上传成功后关闭弹窗
    },
    // 文件上传失败的回调
    handleError(err, file, fileList) {
      console.error('Error uploading file:', err);
      this.$message.error('文件上传失败');
    },

    // 点击上传按钮时触发
    submitProductUpload() {
      this.$refs.upload.submit();
    },
     customRequestProduct(options) {
      const formData = new FormData();
      formData.append('file', options.file); //这里的 'file' 是后端接收文件的字段名
 
      axios.post(this.uploadProductUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        if(response.data.code == '200'){
          options.onSuccess(response.data.message);
          this.dialogVisibleProduct = false;
          this.getPageList();
        }else{
         options.onError(response.data.message);
        }   
      }).catch(error => {
        options.onError(error);
      });
    },
    // 文件上传成功的回调
    handleProductSuccess(response, file, fileList) {
      this.$message.success('上传成功');
      console.log('File uploaded successfully:', response);
      this.dialogVisibleProduct = false; // 上传成功后关闭弹窗
    },
    // 文件上传失败的回调
    handleProductError(err, file, fileList) {
      console.error('Error uploading file:', err);
      this.$message.error('文件上传失败');
    },
    tableHeaderColor({row,column,rowIndex,columnIndex}){
      return 'background-color:#dee1e9;color:#212121;font-weight: 500;'
    },
    // 切换tab
    changeRadio(value) {
      this.searchForm.state = value;
      this.getPageList();
    },
    //搜索
    handleSearch() {
      this.searchForm.page = 1;
      this.getPageList();
    },
    //重置
    handleClear() {
      this.$refs["searchForm"].resetFields();
      this.getPageList();
    },
    // 切换每页显示条数
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.searchForm.page = 1;
      this.getPageList();
    },
    // 点击某一页，跳转某一页
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getPageList();
    },
    changeCourseStatus(id, status) {
      let title = status == 0 ? "下架" : "上架";
      this.$confirm("确认要【" + title + "】该课程吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 业务操作
          this.$axios
            .post("/course/changeStatus", {
              id: id,
              status: status,
            })
            .then((res) => {
              if (res.data.success) {
                this.$message({ message: title + "成功！", type: "success" });
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除
    deletecourse(id) {
      this.$confirm("确认要删除该课程吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除逻辑
          this.$axios
            .delete(url, {
              params: { id: id },
            })
            .then((res) => {
              if (res.data.success) {
                this.$message({ message: "删除成功！", type: "success" });
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openDetail(id) {
      this.$refs.course_detail.drawer = true;
      this.$refs.course_detail.formData.id = id;
      this.$refs.course_detail.getCourseDetail();
    },
    // 路由跳转
    changeView(url, queryParams) {
      console.log(url);
      this.$router.push({
        path: url,
        query: queryParams,
      });
    },
     updateImageUrls() {
      this.productData.forEach(product => {
        product.liveUrl = product.liveUrl.map(imageUrl => {
          // 这里你可以根据需要修改图片 URL
          // 例如，去除查询字符串
          return imageUrl.split('?')[0];
        });
      });
    },

  },
  computed: { 
    isTrackListEmpty(){
        return this.productData.length === 0;
      }
      
  }

};
</script>

<style scoped>
.content {
  margin: 20px 0px;
}

.el-table {
  margin: 20px 0px;
}

.column-custom-class .cell {
  overflow-y: auto;
  max-height: 100px; /* 可以根据需要调整 */
}
.scrollable-cell {
  overflow-x: auto;
  white-space: nowrap;
}

</style>


// WEBPACK FOOTER //
// src/view/product/List.vue